'use client';
export const DEBUG = process.env.NEXT_PUBLIC_DEBUG === 'true' ||
    process.env.DEBUG === 'true' ||
    process.env.REACT_APP_DEBUG === 'true';
